<template>
  <v-card>
    <h1 class="text-pagename text-xs-center">Transfer Management</h1>
    <component
      :is="selectComponantes"
      @selectComponantes="selectComponantes = $event"
    ></component>
  </v-card>
</template>

<script>
import transferListTable from "@/components/back-office/Transfer/TransferListTable";
import startEndTransferList from "@/components/back-office/Transfer/StartEndTransferList";
export default {
  components: {
    transferListTable,
    startEndTransferList,
  },
  data() {
    return {
      selectComponantes: "transferListTable",
    };
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },

      {
        text: "Transfer list",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
</style>